import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getHasCards = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.hasCards;
  }
);
